import { ActionHandler } from 'action-handler';

export default new ActionHandler({
  name: 'trigger_continue_install',
  stateProp: 'continueInstall',
  defaultState: {
    continueInstall: {
      show: false,
      hasBeenSeen: false,
      shouldContinue: false
    }
  },
  handler(continueInstall) {
    return { continueInstall };
  },
  reduce(state, { continueInstall }) {
    return {
      ...state.continueInstall,
      continueInstall
    };
  }
});
